const strings = {
  profile: 'Perfil',
  logout: 'Sair',
}

export default strings
